<template>
  <div
    v-if="productLogoName && productLogoImage"
    class="product-page-brand"
  >
    <component
      :is="productBrandLink ? 'a' : 'span'"
      class="product-page-brand__link"
      :href="productBrandLink ? productBrandLink : ''"
    >
      <img
        class="product-page-brand__logo"
        :src="productLogoImageSrc"
        :alt="productLogoName"
      >
    </component>
  </div>
</template>

<script>
  export default {
    props: {
      productLogoName: String,
      productLogoImage: String,
      productLogoImageSrc: String,
      productBrandLink: String,
    }
  }
</script>
